<script>
import { SysVars } from "../main";
import { apiORDS, apiORDSpost, urlORDS } from "../shared/api-functions";
import BarList from "../components/bar-list";
import PdtipoList from "../forms/pdtipo-list";
import PdstatusList from "../forms/pdstatus-list";
import RegraimpList from "../forms/regraimp-list";
import CondicaoList from "../forms/condicao-list";
import AppMinhaContaForm from "../forms/app-minha-conta-form";
import GrucliList from "../forms/grucli-list";
import RamoatList from "../forms/ramoat-list";
import EquipeList from "../forms/equipe-list";
import UsuarioList from "../forms/usuario-list";
import FilialList from "../forms/filial-list";
import FilialForm from "../forms/filial-form";
import ConfigListLoja from "../forms-loja/config-list-loja";
import TransportadoraList from "../forms/transportadora-list";
import VendList from "../forms/vend-list";
import RegrafcpList from "../forms/regrafcp-list";
import EstadoList from '../forms/estado-list';
import FpagList from '../forms/fpag-list';
import DepoList from '../forms/depo-list';

export default {
  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      activeTab: 0,
      activeTabLink: 0,
      activeTabLinkId: 0,
      configSistema: true,
      configVendas: false,
    };
  },

  components: {
    BarList,
    PdtipoList,
    PdstatusList,
    CondicaoList,
    GrucliList,
    RamoatList,
    EquipeList,
    RegraimpList,
    UsuarioList,
    FilialList,
    FilialForm,
    TransportadoraList,
    ConfigListLoja,
    VendList,
    AppMinhaContaForm,
    RegrafcpList,
    EstadoList,
    FpagList,
    DepoList
  },

  // { title: 'Dados da Empresa', icon: 'fa-building' },
  // { title: 'Usuários', icon: 'fa-user-o' },
  // { title: 'Equipes', icon: 'fa-group' },
  // { title: 'Cond Pagamento', icon: '' },
  // { title: 'Transportadoras', icon: 'fa-truck' },
  // { title: 'Tipos de Pedido', icon: '' },
  // { title: 'Status de Pedido', icon: '' },
  // { title: 'Regras de Imposto', icon: '' },

  computed: {
    tabs: function () {
      let tabs = [];

      if (this.administrador) {
        if (this.configSistema)
          tabs = [
            { title: "Dados da Empresa", icon: "fa-building" },
            { title: "Usuários", icon: "fa-user-o" },
            { title: "Equipes", icon: "fa-group" },
            { title: "Minha Conta", icon: "fa-table" },
          ];
        else
          tabs = [
            { title: "Participantes", icon: "fa-group" },
            { title: "Comercial", icon: "fa-building" },
            { title: "Impostos", icon: "fa-usd" }
          ];
      } else {
        if (this.configSistema)
          tabs = [
            { title: "Usuários", icon: "fa-user-o" }
          ];
        else
          tabs = [
            { title: "Representantes", icon: "" },
            { title: "Transportadoras", icon: "" },
          ];
      }

      return tabs;
    },

    tabEmpresa: function () {
      return this.configSistema && this.activeTab == 0 && this.administrador;
    },

    tabUsuarios: function () {
      if (!this.administrador) return this.configSistema && this.activeTab == 0;
      else return this.configSistema && this.activeTab == 1;
    },

    tabEquipes: function () {
      return this.configSistema && this.activeTab == 2;
    },

    tabConta: function () {
      return this.configSistema && this.activeTab == 3;
    },

    tabRepresentante: function () {
      return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 0;
    },

    tabTransp: function () {
      if (!this.administrador) return this.configVendas && this.activeTab == 1;
      else return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 4;
    },

    tabGrupoCliente: function () {
      return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 1;
    },

    tabSegmento: function () {
      return this.configVendas && this.activeTab == 0 && this.activeTabLinkId == 2;
    },

    tabCondicoes: function () {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 3;
    },

    tabFormasPag: function () {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 10;
    },

    tabTipos: function () {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 5;
    },

    tabStatus: function () {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 6;
    },

    tabRegras: function () {
      return this.configVendas && this.activeTab == 2 && this.activeTabLinkId == 7;
    },

    tabRegrasFcp: function () {
      return this.configVendas && this.activeTab == 2 && this.activeTabLinkId == 8;
    },

    tabEstados: function () {
      return this.configVendas && this.activeTab == 2 && this.activeTabLinkId == 9;
    },

    tabDepositos: function () {
      return this.configVendas && this.activeTab == 1 && this.activeTabLinkId == 11;
    },
 
    appForcaVendas: function () {
      return SysVars.appForcaVendas
    },
    appLoja: function () {
      return SysVars.appLoja
    },
    tabLinks: function () {
      if (this.activeTab === 0) {
        return [
          { id: 0, title: "Representantes", icon: "" },
          { id: 4, title: "Transportadoras", icon: "" },
          { id: 1, title: "Grupos de Cliente", icon: "" },
          { id: 2, title: "Segmentos de Cliente", icon: "" }
        ]
      }

      if (this.activeTab === 1) {
        const tabs =  [
          { id: 3, title: "Condições de Pagamento", icon: "" },
          { id: 10, title: "Formas de Pagamento", icon: "" },
          { id: 5, title: "Tipos de Pedido", icon: "" },
          { id: 6, title: "Status de Pedido", icon: "" },
          { id: 11, title: "Depósitos", icon: "" }
        ]
        if (!this.appForcaVendas && !this.appLoja) {
          tabs.splice(0, 1);
        }
        return tabs
      }

      if (this.activeTab === 2) {
        return [
          { id: 7, title: "Regras de Imposto", icon: "" },
          { id: 8, title: "Alíquotas do FCP", icon: "" },
          { id: 9, title: "Estados", icon: "" }
        ]
      }

      return []
    },

    administrador: function () {
      return SysVars.usuarioAdministrador;
    },
  },

  methods: {
    changeTab(idx) {
      this.activeTab = idx;
      this.activeTabLink = 0;

      if (!this.configSistema) {
        this.activeTabLinkId = this.tabLinks[0].id
      }
    },

    changeTabLink(idx) {
      const link = this.tabLinks[idx]
      this.activeTabLink = idx;
      this.activeTabLinkId = link.id;
    },

    handleConfigSistema() {
      this.configVendas = false;
      this.configSistema = true;
    },

    handleConfigVendas() {
      this.configVendas = true;
      this.configSistema = false;
    },
  },

  created() {
    if(this.$route.query.myaccount){
      this.changeTab(3);
    } 
  },
};
</script>

<template>
  <div>
    <!-- <bar-list
            :refresh-button="false" 
            single-entity="Configurações Varejo" 
            plural-entity="Configurações Varejo"
            @refresh="loadData">
        </bar-list> -->

    <div class="d-flex py-3">
      <v-button
        label="Configurações da Empresa"
        @click="handleConfigSistema"
        :nb-btdef="configSistema"
        icon=""
      ></v-button>
      <v-button
        label="Configurações Comerciais"
        @click="handleConfigVendas"
        :nb-btdef="configVendas"
        icon=""
      ></v-button>
    </div>

    <!-- <tabs :tabs="tabs2" :setActiveTab="activeTab2" @onClickTab="changeTab2"></tabs> -->

    <tabs
      v-if="configSistema"
      :tabs="tabs"
      :setActiveTab="activeTab"
      @onClickTab="changeTab"
    ></tabs>
    <tabs
      v-if="configVendas"
      :tabs="tabs"
      :setActiveTab="activeTab"
      @onClickTab="changeTab"
    ></tabs>
    <tabs
      v-if="configVendas && tabLinks.length"
      :tabs="tabLinks"
      :setActiveTab="activeTabLink"
      @onClickTab="changeTabLink"
    ></tabs>

    <div class="nb-margin-top pt-5">
      <transition v-if="tabEmpresa">
        <filial-list></filial-list>
      </transition>

      <transition v-if="tabUsuarios">
        <usuario-list></usuario-list>
      </transition>

      <transition v-if="tabEquipes">
        <equipe-list></equipe-list>
      </transition>

      <transition v-if="tabConta">
        <app-minha-conta-form></app-minha-conta-form>
      </transition>

      <transition v-if="tabCondicoes">
        <condicao-list></condicao-list>
      </transition>

      <transition v-if="tabFormasPag">
        <fpag-list></fpag-list>
      </transition>

      <transition v-if="tabTransp">
        <transportadora-list></transportadora-list>
      </transition>

      <transition v-if="tabStatus">
        <pdstatus-list></pdstatus-list>
      </transition>

      <transition v-if="tabTipos">
        <pdtipo-list></pdtipo-list>
      </transition>

      <transition v-if="tabRegras">
        <regraimp-list></regraimp-list>
      </transition>

      <transition v-if="tabRegrasFcp">
        <regrafcp-list></regrafcp-list>
      </transition>

      <transition v-if="tabEstados">
        <estado-list></estado-list>
      </transition>

      <transition v-if="tabSegmento">
        <ramoat-list></ramoat-list>
      </transition>

      <transition v-if="tabGrupoCliente">
        <grucli-list></grucli-list>
      </transition>

      <transition v-if="tabRepresentante">
        <vend-list></vend-list>
      </transition>

      <transition v-if="tabDepositos">
        <depo-list></depo-list>
      </transition>

    </div>
  </div>
</template>

<style>
</style>



// WEBPACK FOOTER //
// src/forms-fv/fv-config-menu.vue